export default function NoRowFallback ({ title = '' } : { title: string }) {
  return (
    <div className="p-2 text-center col-span-full">
      <p className="italic ">ไม่มีรายการ{title}</p>
    </div>
  );
}